// =============================================================================
// alarm-names — mapping alarm code (integer) → nama human-readable.
//
// SUMBER KEBENARAN: servergps/src/main/java/com/pusatgps/model/AlarmCode.java
// (penomoran yang dipancarkan decoder & tersimpan di tabel tracks_alarm).
// JANGAN ubah angka tanpa menyamakan AlarmCode.java + dispatcher api-server.
// =============================================================================

export const ALARM_NAMES: Record<number, string> = {
  0:  'Tanpa Alarm',
  1:  'SOS / Panic',
  2:  'Power Cut',
  3:  'Battery GPS Lemah',
  4:  'Guncangan (Shock)',
  5:  'Over Speed',
  6:  'Kecepatan Rendah',
  7:  'Masuk Geofence',
  8:  'Keluar Geofence',
  9:  'Parkir Melebihi Batas',
  10: 'Kendaraan Berpindah',
  11: 'Idle',
  12: 'Pengingat Servis',
  13: 'Keluar Rute',
  14: 'IO1 Aktif',
  15: 'IO1 Nonaktif',
  16: 'IO2 Aktif',
  17: 'IO2 Nonaktif',
  18: 'IO3 Aktif',
  19: 'IO3 Nonaktif',
  20: 'IO4 Aktif',
  21: 'IO4 Nonaktif',
  22: 'IO5 Nonaktif',
  23: 'IO5 Aktif',
  24: 'IO6 Nonaktif',
  25: 'IO6 Aktif',
  26: 'Antena GSM Putus',
  27: 'Antena GPS Putus',
  28: 'Jammer Aktif',
  29: 'GSM Jammed',
  30: 'GSM Jammed Selesai',
  31: 'GPS Jammed Selesai',
  32: 'Driver Mengantuk',
  33: 'Fatigue Selesai',
  34: 'Masuk Sleep Mode',
  35: 'Keluar Sleep Mode',
  36: 'Akselerasi',
  37: 'Berhenti Mendadak',
  38: 'Daya Eksternal Terhubung',
  39: 'Daya Eksternal Lemah',
  40: 'Pintu Dibuka',
  41: 'Pintu Ditutup',
  42: 'Pengiriman Melebihi Waktu',
  43: 'Tiba di Tujuan',
  44: 'Parkir Lama di Geofence',
  45: 'Bergerak (Range Tanggal)',
  46: 'Masuk POI',
  47: 'Keluar POI',
  48: 'ACC On',
  49: 'ACC Off',
  50: 'Tidak Update',
  51: 'Alarm Suhu',
  52: 'Alarm Oli/BBM',
  53: 'Kendaraan Kecelakaan',
  54: 'GPS Dilepas',
  55: 'Alarm Umum',
  56: 'Kerja Lembur',
  57: 'Power On',
  58: 'GPS Dibongkar',
  59: 'Masuk Dead Zone',
  60: 'Keluar Dead Zone',
  61: 'Tidak Ada Data Satelit',
  62: 'Tidak Ada Satelit',
  63: 'Menikung Tajam',
  64: 'Casing GPS Dibuka',
  65: 'Mode Pesawat',
  66: 'SIM Diganti',
  67: 'DMS (Driver Monitoring)',
  68: 'ADAS',
  69: 'Peringatan Tabrakan Depan',
  70: 'Keluar Jalur',
  71: 'Tabrakan Terdeteksi',
  72: 'Rem Mendadak',
  73: 'Sabuk Pengaman Lepas',
  74: 'BBM Dicuri/Rendah',
  75: 'SD Card Error',
  76: 'Getaran Terdeteksi',
  77: 'Kelelahan Driver',

  // Custom internal (api-server side, di luar AlarmCode.java)
  9001: 'Rental Jatuh Tempo',
  9002: 'Maintenance Due',
  9003: 'Geofence Worker Alert',
};

/**
 * alarmName — ambil nama alarm. Fallback ke "Alarm <code>" kalau tidak ada
 * di mapping. Bisa di-override caller (mis. pakai nama dari WS payload yg
 * lebih spesifik kalau ada).
 */
export function alarmName(code: number, override?: string): string {
  if (override && override.trim()) return override;
  return ALARM_NAMES[code] ?? `Alarm ${code}`;
}
